import React from 'react';
import { Utils } from '@adobe/aem-react-editable-components';
import { ComponentPlaceholder } from '@yme/atoms/component-placeholder';
import { colorCoreWhite1000 } from '@yme/tokens/colors';
import { ExperienceFragment } from '../ExperienceFragment/ExperienceFragment';
import { ContentStyled } from './styled';
export function CheckoutContent(props) {
    const { steps = {} } = props;
    const propsToRender = steps[window.location.hash];
    if (!propsToRender) {
        return React.createElement(ComponentPlaceholder, { title: "Checkout Content" });
    }
    return (React.createElement(ContentStyled, { colProps: {
            bgColor: colorCoreWhite1000,
        } },
        React.createElement(ExperienceFragment, { ...Utils.modelToProps(propsToRender) })));
}
CheckoutContent.displayName = 'CheckoutContent';
